import React from 'react'
import Thiyapediacomp1 from '../components/Thiyapediacomp1'
import Thhiyapediacomp2 from '../components/Thhiyapediacomp2'

function Thiyapedia() {
  return (
    <div>
        <Thiyapediacomp1/>
        <Thhiyapediacomp2/>
    </div>
  )
}

export default Thiyapedia